import EventStats from '@/screens/EventStats';

export default function PrivateTabsEventEventIdStatsRoute() {
  return <EventStats />;
}
